import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse, ForkLiftJobStatus } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { In, Repository } from 'typeorm';
import { CreateNotification } from './dto/create-notification.dto';
import { PlantIdRequest } from './dto/plant-id.request';
import { UpdateNotification } from './dto/update-notification.dto';
import { Notifications } from './notifications.entity';

@Injectable()
export class NotificationsService {
    constructor(@InjectRepository(Notifications) private repository:  Repository<Notifications>) {
    }

        /**
     * Service to create new notification
     * @param createNotificationDto 
     * @returns 
     */
    async createNotification(createNotificationDto: CreateNotification): Promise<CommonResponse> {
            const notificationEntity = new Notifications();            
            notificationEntity.plantId = createNotificationDto.plantId;
            notificationEntity.palletId = createNotificationDto.palletId;
            notificationEntity.jobId = createNotificationDto.jobId;
            notificationEntity.status = createNotificationDto.status;
            notificationEntity.statusMsg = createNotificationDto.statusMessage;
            notificationEntity.createdUser = createNotificationDto.createdUser;
            await this.repository.save(notificationEntity);    
            return new CommonResponse(true, 10000, 'Notification Created Successfully');
    }

    /**
     * Service to update a notification details
     * @param updateNotificationDto 
     * @returns 
     */
    async updateNotification(updateNotificationDto: UpdateNotification): Promise<CommonResponse> {
        const notificationEntity = await this.repository.findOne({
            where: { jobId: updateNotificationDto.verificationJobId },
        });
        if(!notificationEntity) {
            throw new ErrorResponse(10000, 'Notification details not found');
        } else {
            notificationEntity.plantId = updateNotificationDto.plantId;
            notificationEntity.palletId = updateNotificationDto.palletId;
            notificationEntity.jobId = updateNotificationDto.jobId;
            notificationEntity.status = updateNotificationDto.status;
            notificationEntity.statusMsg = updateNotificationDto.statusMessage;
            notificationEntity.updatedUser = updateNotificationDto.updatedUser;
            await this.repository.save(notificationEntity);  
            return new CommonResponse(true, 10000, 'Notification Details Updated Successfully');
        }
    }

    /**
     * Service to get all the notifications
     * @returns 
     */
    async getAllNotifications(req:PlantIdRequest): Promise<CommonResponse> {
        const notificationResponse = await this.repository.find({
            where:{plantId:req.plantId},
            order:{notificationId: "ASC"},
        });

        const notificationDetails = [];
        if (notificationResponse.length === 0) {
            throw new ErrorResponse(9999, 'Notification details not found');
        }
        for(const notification of notificationResponse) {
            notificationDetails.push({notificationId:notification.notificationId,plantId:notification.plantId,palletId:notification.palletId,jobId:notification.jobId,status:notification.status,statusMsg:notification.statusMsg,createdUser:notification.createdUser,createdAt:notification.createdAt,updatedUser:notification.updatedUser,updateAt:notification.updatedAt});
        }
        return new CommonResponse(true, 10000, 'Notification Details Retrived Successfully', notificationDetails);
       
    }

    /**
     * Service to get all open the notifications by plant id
     * @param plantIdReq
     * @returns 
     */
     async getOpenNotificationsByPlantId(plantIdReq: PlantIdRequest): Promise<CommonResponse> {
        const notificationResponse = await this.repository.find({
            where: {plantId: plantIdReq.plantId,status: In([ForkLiftJobStatus.Open,ForkLiftJobStatus.Pending])},
            order:{notificationId: "ASC"},
        });

        const notificationDetails= [];
        if (notificationResponse.length === 0) {
            throw new ErrorResponse(9999, 'Notification details not found');
        }
        for(const notification of notificationResponse) {
            notificationDetails.push({notificationId:notification.notificationId,plantId:notification.plantId,palletId:notification.palletId,jobId:notification.jobId,status:notification.status,statusMsg:notification.statusMsg,createdUser:notification.createdUser,createdAt:notification.createdAt,updatedUser:notification.updatedUser,updateAt:notification.updatedAt});
        }
        return new CommonResponse(true, 10000, 'Notification Details Retrived Successfully', notificationDetails);
    }
}
